import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
// if (!localStorage.getItem("redirectToPage")) {
//   const currentPath = window.location.pathname; // current URL path
//   localStorage.setItem("redirectToPage", currentPath);
//   console.log("Stored redirect path:", currentPath);
// }
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
    <Toaster />
  </>
);
